import React, { FC } from 'react';
import { SatisfactionModalInputProps } from './SatisfactionModalInputProps';
import { Stack } from '@mui/material';
import TextArea from '@ingka/text-area';

const SatisfactionModalInput: FC<SatisfactionModalInputProps> = ({
  value,
  onChange,
}) => {
  return (
    <Stack>
      <TextArea
        label="Feel free to share feedback around your experience"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </Stack>
  );
};

export default SatisfactionModalInput;
